const metodeBayar = [
    {
        title: "Tunai",
        subtitle: "Bayar menggunakan uang tunai",
        id: "1",
        value: "1",
        isBayar: true,
    },
    {
        title: "Transfer Bank",
        subtitle: "Bayar melalui transfer bank",
        id: "3",
        value: "3",
        isBayar: true,
    },
    {
        title: "EDC",
        subtitle: "Bayar melalui EDC",
        id: "11",
        value: "11",
        isBayar: false
    },
    {
        title: "Qris",
        subtitle: "Bayar melalui Qris",
        id: "10",
        value: "10",
        isBayar: false,
    }
];

export default metodeBayar;
